import React, { useEffect, useState } from "react";
import { useRef } from "react";
import { useSearchParams, useLocation } from "react-router-dom";
import cloudlasLogo from "../../assets/images/cloud-logo.png";
import AppConstants from "../../common/AppConstants";
import CommonMethods from "../../common/CommonMethods";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import { Container } from "react-bootstrap";

function Header() {
  const headerRef: any = useRef(null);
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    if (!searchParams.get("goto")) {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    }
    setExpanded(false);
  }, [location]);

  // Sticky Menu Area
  useEffect(() => {
    /* Method that will fix header after a specific scrollable */
    const isSticky = (e: any) => {
      const scrollTop = window.scrollY;
      scrollTop >= 60
        ? headerRef.current.classList.add("smaller")
        : headerRef.current.classList.remove("smaller");
    };

    window.addEventListener("scroll", isSticky);

    return () => {
      window.removeEventListener("scroll", isSticky);
    };
  }, []);

  return (
    <>
      {/* <div id="topbar"></div> */}

      <header ref={headerRef} className="navbar navbar-expand-lg header">
        <div
          className="container main myHeader"
          data-aos="fade-down"
          data-aos-delay="30"
          data-aos-duration="1000"
        >
          <a
            className="navbar-brand"
            href={CommonMethods.getRouteLink(AppConstants.Views.Home)}
          >
            <img src={cloudlasLogo} alt="" />
          </a>
          <Navbar
            expand="lg"
            className="navbar-nav mx-auto mb-2 mb-lg-0"
            expanded={expanded}
          >
            <Container>
              <Navbar.Toggle
                aria-controls="basic-navbar-nav"
                onClick={() => setExpanded(!expanded)}
              />
              <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="me-auto">
                  <Nav.Link
                    href={CommonMethods.getRouteLink(AppConstants.Views.Home)}
                  >
                    Home
                  </Nav.Link>
                  <Nav.Link
                    href={`${CommonMethods.getRouteLink(
                      AppConstants.Views.Home
                    )}?goto=about-us`}
                  >
                    About Us
                  </Nav.Link>
                  <NavDropdown title="Products" id="basic-nav-dropdown">
                    <NavDropdown.Item
                      href={CommonMethods.getRouteLink(
                        AppConstants.Views.Products.KPI
                      )}
                    >
                      KPI And Analytics
                    </NavDropdown.Item>
                    <NavDropdown.Item
                      href={CommonMethods.getRouteLink(
                        AppConstants.Views.Products.ScrumMaster
                      )}
                    >
                      Scrum Master
                    </NavDropdown.Item>
                    <NavDropdown.Item
                      href={CommonMethods.getRouteLink(
                        AppConstants.Views.Products.HelpDesk
                      )}
                    >
                      HelpDesk Portal
                    </NavDropdown.Item>
                    <NavDropdown.Item
                      href={CommonMethods.getRouteLink(
                        AppConstants.Views.Products.Directory
                      )}
                    >
                      Employee Directory And Org Chart
                    </NavDropdown.Item>
                  </NavDropdown>
                  <NavDropdown title="Documentations" id="basic-nav-dropdown">
                    <NavDropdown.Item
                      href={CommonMethods.getRouteLink(
                        AppConstants.Views.Documentation.KPI
                      )}
                    >
                      KPI And Analytics
                    </NavDropdown.Item>
                    {/* <NavDropdown.Item
                      href={CommonMethods.getRouteLink(
                        AppConstants.Views.Documentation.ScrumMaster
                      )}
                    >
                      Scrum Master
                    </NavDropdown.Item>
                    <NavDropdown.Item
                      href={CommonMethods.getRouteLink(
                        AppConstants.Views.Documentation.HelpDesk
                      )}
                    >
                      Help Desk Portal
                    </NavDropdown.Item>
                    <NavDropdown.Item
                      href={CommonMethods.getRouteLink(
                        AppConstants.Views.Documentation.Directory
                      )}
                    >
                      Employee Directory And Org Chart
                    </NavDropdown.Item> */}
                  </NavDropdown>
                  <Nav.Link
                    href={CommonMethods.getRouteLink(
                      AppConstants.Views.ContactUs
                    )}
                  >
                    Contact Us
                  </Nav.Link>
                </Nav>
              </Navbar.Collapse>
            </Container>
          </Navbar>
          {/* <a
            id="submit_btn3"
            className="prod-btn btn-primary px-4 requestDemoButton"
            href={"#/"}
            target="_blank"
          >
            Request A Demo
          </a> */}
          {/* <button
            className="navbar-toggler collapsed"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon close-mob">
              <img src="assets/images/clos-mob.jpeg" alt="" />
            </span>
            <span className="navbar-toggler-icon open-mob">
              <img src="assets/images/burg-link.png" alt="" />
            </span>
          </button> */}
          {/* <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav mx-auto mb-2 mb-lg-0">
              <li className="nav-item dropdown position-static">
                <a
                  className="nav-link"
                  href={CommonMethods.getRouteLink(AppConstants.Views.Home)}
                >
                  Home{" "}
                </a>
              </li>
              <li className="nav-item dropdown position-static">
                <a
                  className="nav-link"
                  href={`${CommonMethods.getRouteLink(
                    AppConstants.Views.Home
                  )}?goto=about-us`}
                >
                  About Us{" "}
                </a>
              </li>
            
              <li className="nav-item dropdown position-static">
                <a
                  className="nav-link "
                  href=""
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Products
                  <span className="drop">
                    <img src="assets/images/drop.jpeg" alt="" />
                  </span>
                </a>
                <ul className="dropdown-menu">
                  <li>
                    <a
                      className="dropdown-item"
                      href={CommonMethods.getRouteLink(
                        AppConstants.Views.Products.KPI
                      )}
                    >
                      KPI And Analytics
                    </a>
                  </li>
                  <li>
                    <a
                      className="dropdown-item"
                      href={CommonMethods.getRouteLink(
                        AppConstants.Views.Products.ScrumMaster
                      )}
                    >
                      Scrum Master
                    </a>
                  </li>
                  <li>
                    <a
                      className="dropdown-item"
                      href={CommonMethods.getRouteLink(
                        AppConstants.Views.Products.HelpDesk
                      )}
                    >
                      Help Desk Portal
                    </a>
                  </li>
                  <li>
                    <a
                      className="dropdown-item"
                      href={CommonMethods.getRouteLink(
                        AppConstants.Views.Products.Directory
                      )}
                    >
                      Employee Directory And Org Chart
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
            <div className="d-flex">
              <a
                href={CommonMethods.getRouteLink(AppConstants.Views.ContactUs)}
                className="btn btn-primary"
              >
                Contact US
              </a>
            </div>
          </div> */}
        </div>
      </header>
    </>
  );
}
export default Header;
